import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import { HowItWorksModalProvider } from './context/HowItWorksModalContext';
import AppShell from './AppShell';
import './utils/waitlistSubmit';

export default function App() {
  return (
    <HowItWorksModalProvider>
      <AppProvider>
        <BrowserRouter>
          <AppShell />
        </BrowserRouter>
      </AppProvider>
    </HowItWorksModalProvider>
  );
}
